export type AccessibleRole = 'button' | 'link'

const ACTIVATION_KEYS: Record<AccessibleRole, readonly string[]> = {
  button: ['Enter', ' '],
  link: ['Enter'],
}

export const isActivationKey = (role: AccessibleRole, key: string) =>
  ACTIVATION_KEYS[role].includes(key)
